import { render, staticRenderFns } from "./clientsView.vue?vue&type=template&id=b75ac814&"
import script from "./clientsView.vue?vue&type=script&lang=js&"
export * from "./clientsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports